import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../core';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';
import { catchError, map } from 'rxjs/operators';
import { CertificadoDigital } from '../modelo/CertificadoDigital';
import { CuentaBancaria } from '../modelo/CuentaBancaria';
import { Organization } from '../modelo/Organization';
import { Subject } from '../modelo/Subject';
import { UsuarioModel } from '../modelo/usuario.model';
import { DataService } from '../services/data.service';

@Injectable({
    providedIn: 'root'
})
export class PerfilService {

    private apiServer = '';
    private handleError: HandleError;

    constructor(
        private apiService: ApiService,
        private httpErrorHandler: HttpErrorHandler,
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('PerfilService');
    }

    /*************************************************************************************
    **UsersController
    **************************************************************************************/
    /**   
    * Subject
    **/
    async getUserImageData(): Promise<any> {
        return this.getUserImage().toPromise();
    }
    getUserImage() {
        return this.apiService.get(this.apiServer + '/user/image')
            .pipe(
                catchError(this.handleError('PerfilService.getUserImage'))
            )
    }

    enviarCertificado(certificadoDigital: CertificadoDigital) {
        if (certificadoDigital.base64 && certificadoDigital.password) {
            return this.apiService.post(this.apiServer + '/comprobantes/firmaelectronica', certificadoDigital)
                .pipe(map(data => data));
        }
    }

    enviarUser(user: UsuarioModel) {
        user.password = "e9800998ecf8427ed41d8cd98f00b204"; //Para poder cargar la data
        if (user.code && user.email && user.password) {
            if (user.uuid) {
                return this.apiService.put(this.apiServer + '/users', user)
                    .pipe(map(data => data['user']));
            } else {
                return this.apiService.post(this.apiServer + '/users', user)
                    .pipe(map(data => data['user']));
            }
        }
    }

    /**   
    * Organization
    **/
    async getUserOrganizationImageData(): Promise<any> {
        return this.getUserOrganizationImage().toPromise();
    }
    getUserOrganizationImage() {
        return this.apiService.get(this.apiServer + '/user/organization/image')
            .pipe(
                catchError(this.handleError('PerfilService.getUserOrganizationImage'))
            )
    }

    async getUserOrganizationPorUsuarioData(usuarioId: number): Promise<any> {
        return this.getUserOrganizationPorUsuario(usuarioId).toPromise();
    }
    
    getUserOrganizationPorUsuario(usuarioId: number) {
        return this.apiService.get(this.apiServer + '/organization/usuario/' + usuarioId)
            .pipe(
                catchError(this.handleError('PerfilService.getUserOrganizationImage'))
            )
    }

    enviarOrganization(organization: Organization) {
        
        let data:Organization = organization;
        data.establecimientos = null; //Quitar de la tram de datos
        return this.apiService.put(this.apiServer + '/organization', organization)
            .pipe(map(data => data));
    }

    /**   
    * CuentaBancaria
    **/
    async getCuentasBancariasPorOrganizacionDeUsuarioConectadoData(): Promise<any> {
        return this.getCuentasBancariasPorOrganizacionDeUsuarioConectado().toPromise();
    }
    getCuentasBancariasPorOrganizacionDeUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/organization/cuentabancaria/activos')
            .pipe(
                catchError(this.handleError('PerfilService.getCuentasBancariasPorOrganizacionDeUsuarioConectado'))
            );
    }

    enviarCuentaBancaria(cuentaBancaria: CuentaBancaria) {
        if (cuentaBancaria.uuid) {
            return this.apiService.put(this.apiServer + '/organization/cuentabancaria', cuentaBancaria)
                .pipe(map(data => data['cuentaBancaria']));
        } else {
            return this.apiService.post(this.apiServer + '/organization/cuentabancaria', cuentaBancaria)
                .pipe(map(data => data['cuentaBancaria']));
        }
    }

    eliminarCuentaBancaria(uuid: string) {
        return this.apiService.delete(this.apiServer + '/organization/cuentabancaria/' + uuid)
            .pipe(
                catchError(this.handleError('PerfilService.eliminarCuentaBancaria'))
            );
    }

}
